import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiEnhanceMinutes(notesText: string, meetingType: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a senior project manager. The user's raw meeting notes are below. Produce: 1) 3-sentence summary, 2) Decisions (bulleted, owner if mentioned), 3) Action items table (task | owner | due | priority), 4) Open questions, 5) 2-3 risks the meeting surfaced. Meeting type: ${meetingType}. Markdown.`;
  try {
    await streamGroq({ messages: [{ role: 'system', content: system }, { role: 'user', content: notesText.slice(0, 10000) }], temperature: 0.3, onStream });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key. The pattern engine works fully without it.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
